// extracted by mini-css-extract-plugin
export default {"wrapper":"fBvPAqGEMBCpN3vpP6VO","text":"egzFxioOiFP9Oq00zWSt","buttonLink":"ZB3FcjgbNh7fiXXQ7iWb"};